mutation SubmitCustomerGuideDraft($input: CustomerGuideDraftSubmitInput!) {
  submitCustomerGuideDraft(input: $input) {
    conflict
    replacementInProgress
    draft {
      draftId
      revision
      status
    }
    guide {
      materialId
      publishedVersion
      publishedFile {
        id
        cdnUrl(named: true)
      }
      previewFile {
        id
        cdnUrl
      }
      replacementState
      failureState
      canRegenerate
      canEdit
    }
  }
}
